/* eslint-disable import/no-mutable-exports */
import IConfig from './IConfig';
// import butterflyConfig from './butterfly';
// import butterConfig from './butter';
// import gygConfig from './gyg';
// import airmilesConfig from './airmiles';
import localConfig from './local';

const config: IConfig = localConfig;
// const env = process.env.REACT_APP_ENV?.trim();
// if (env === 'butterfly') config = butterflyConfig;
// else if (env === 'butter') config = butterConfig;
// else if (env === 'gyg') config = gygConfig;
// else if (env === 'airmiles') config = airmilesConfig;
// else

declare global {
  interface Window {
    twindow: {
      map?: google.maps.Map;
      planBounds?: google.maps.LatLngBounds | null;
      cityBounds?: google.maps.LatLngBounds | null;
      meMarker?: google.maps.Marker;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      config?: any;
    };
  }
}
window.twindow = window.twindow || {};
window.twindow.config = config;

export default config;
